import { FC, useState, useCallback } from 'react';
import { Box, Typography, SxProps, TextField } from '@mui/material';
import { clsx, useStyles } from '@sweatpals/react-ui-kit';
import { getNewsletterSectionStyles } from './get-newsletter-section.styles';
import AppButton from '@/modules/_core/components/buttons/app-button.component';
import { usersService } from '@/modules/_core/services';
import { isEmail } from 'class-validator';

export interface GetNewsLetterSectionProps {
	sx?: {
		root?: SxProps;
	};
}

const GetNewsLetterSectionV2: FC<GetNewsLetterSectionProps> = ({ sx }) => {
	const [email, setEmail] = useState('');
	const [isEmailError, setIsEmailError] = useState(false);
	const [isSubscribed, setIsSubscribed] = useState(false);

	const handleEmailChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
		setEmail(event.target.value);

		setIsEmailError(false);
	}, []);

	const handleSubscribe = useCallback(async () => {
		if (!email) return;

		if (!isEmail(email)) {
			setIsEmailError(true);

			return;
		}

		const preparedEmail = email.trim();

		await usersService.addToNewsletter(preparedEmail);

		setIsSubscribed(true);
		setEmail('');
	}, [email]);

	const styles = useStyles(getNewsletterSectionStyles);

	return (
		<Box sx={clsx(styles.flexColumn, styles.itemsCenter, styles.root, sx?.root)}>
			<Box sx={clsx(styles.flexRowWrap, styles.flexCenter, styles.titleRow)}>
				<Typography sx={styles.titleBold}>subscribe</Typography>
				<Typography sx={styles.titleItalic}>to our</Typography>
				<Typography sx={styles.titleBold}>newsletter</Typography>
			</Box>

			<Typography sx={styles.subtitle}>
				Treat your inbox with the latest events, discount, community announcement
			</Typography>
			<Box sx={clsx(styles.flexRow, styles.itemsCenter, styles.inputs)}>
				<TextField
					name="email"
					variant="standard"
					type="email"
					placeholder="Enter your email"
					sx={styles.textField}
					value={email}
					onChange={handleEmailChange}
					autoComplete="email"
					error={isEmailError}
					helperText={isEmailError ? 'Please enter a valid email' : ''}
				/>
				<AppButton sx={styles.subscribeButton} onClick={handleSubscribe}>
					{isSubscribed ? 'Subscribed succesfully' : 'Subscribe'}
				</AppButton>
			</Box>
		</Box>
	);
};

export default GetNewsLetterSectionV2;
